export const integrationsRouteNames = {
  default: 'integration-v2',
  appUpgradePlans: 'integration_app_upgrade_plans',
  subRoute:'integration_app_any_location'
}
